import { COMMON_CONSTS } from '../common/common.consts'

export const AUTH_CONSTS = {
  moduleName: 'epb-auth',

  getters: {
    token: 'token',
    tokenInfo: 'tokenInfo',
    isLoggedIn: 'isLoggedIn',
    keepLoggedIn: 'keepLoggedIn',
  },
  actions: {
    ...COMMON_CONSTS.actions,
    loadStateFromStorage: 'loadStateFromStorage',
    login: 'login',
    logout: 'logout',
    refresh: 'refresh',
    setToken: 'setToken',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
    setState: 'setState',
  },

  storage: {
    token: 'auth-token',
    refreshToken: 'refresh-token',
    keepLoggedIn: 'keep-logged-in',
  },
}
